import React from 'react';
import styles from './Loader.module.css';
import PropTypes from 'prop-types';

function Loader(props) {
    const displayClass = props.loading ? styles.Show : styles.Hide;
    const loaderTypeClass = props.type === "inline" ? styles.Inline : styles.FullWidth;
    
    return <div className={[styles.Loader, displayClass, loaderTypeClass].join(' ')}> { props.text } </div>
}

Loader.propTypes = {
    loading: PropTypes.bool
}

export default Loader

